// src/pages/FormsPage.tsx
import React, { useEffect, useState, JSX } from "react";
import { useOutletContext } from "react-router-dom";
import "../../index.css";
// import { SidebarItem } from "../../components/Center Admin/layout/CenterAppointmentsQueue";
import "../../center admin css/centerAdmin.css";
import api from "../../api/axiosConfig";

// Form components
import { AnthropometricMeasurementForm } from "../../components/Center Admin/forms/AnthropometricMeasurementForm";
import { PhysicalExaminationForm } from "../../components/Center Admin/forms/PhysicalExaminationForm";
import { ADMinorSymptomsExaminationForm } from "../../components/Center Admin/forms/ADMinorSymptomsExaminationForm";
import { BUSampleForm } from "../../components/Center Admin/forms/BUSampleForm";
import BnuSampleForm from "../../components/Center Admin/forms/sentToLab";
import LabReportForm from "../../components/Center Admin/forms/LabReportForm";
import { VisionScreeningForm } from "../../components/Center Admin/forms/VisionScreeningForm";
import { OralImagingForm } from "../../components/Center Admin/forms/OralImagingForm";
import { VitalsExaminationForm } from "../../components/Center Admin/forms/VitalsExaminationForm";
import { SalivaSampleForm } from "../../components/Center Admin/forms/SalivaSampleForm";
import { CariogramInputForm } from "../../components/Center Admin/forms/CariogramInputForm";
import AudiologyScreeningForm from "../../components/Center Admin/forms/AudiologyScreeningForm";
import Nurse1PatientQueue from "../../components/Center Admin/Reuse/Nurse1PatientQueue";
import Nurse1ActivePatientCard from "../../components/Center Admin/Reuse/Nurse1ActivePatientCard";
import Nurse2PatientQueue from "../../components/Center Admin/Reuse/Nurse2PatientQueue";
import Nurse2ActivePatientCard from "../../components/Center Admin/Reuse/Nurse2ActivePatientCard";
import Nurse3PatientQueue from "../../components/Center Admin/Reuse/Nurse3PatientQueue";
import Nurse3ActivePatientCard from "../../components/Center Admin/Reuse/Nurse3ActivePatientCard";

const normalize = (s?: string) =>
  (s ?? "").toString().trim().toUpperCase().replace(/\s+/g, " ");

type BackendForm = {
  _id?: string;
  name?: string;
  key?: string;
  isActive?: boolean;
};

type AllowedForm = {
  id: string;
  label: string;
  render: (emrId: string) => JSX.Element;
};

// 🔥 NEW: Nurse Tabs Mapping (ONLY ADDITION)

const NURSE_FORM_FILTERS: Record<string, string[]> = {
  "nurse 1": [
    "AD MINOR SYMPTOMS EXAMINATION",
    "PHYSICAL EXAMINATION",
    "ANTHROPOMETRIC MEASUREMENT",
    "B&U SAMPLE",
    "BLOOD AND URIN SAMPLE COLLECTED",
    "BLOOD AND URINE SAMPLE COLLECTED",
  ],

  "nurse 2": [
    "VITALS EXAMINATION",
    "B&U SAMPLE",
    "BLOOD AND URIN SAMPLE COLLECTED",
    "BLOOD AND URINE SAMPLE COLLECTED",
  ],

  "nurse 3": [
    "CARIOGRAM SALAIVA SAMPLE",
    "CARIOGRAM INPUT",
    "ORAL IMAGING",
    "B&U SAMPLE",
    "BLOOD AND URIN SAMPLE COLLECTED",
    "BLOOD AND URINE SAMPLE COLLECTED",
  ],
};

function readJSON(store: Storage, key: string) {
  try {
    const raw = store.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function loadUserAnywhere(): any | null {
  const keys = [
    "currentUser",
    "CurrentResponse",
    "CurrrentResponse",
    "backendResponse",
  ];
  for (const k of keys) {
    const s = readJSON(sessionStorage, k);
    if (s) return s;
    const l = readJSON(localStorage, k);
    if (l) return l;
  }
  return null;
}

const NursePage: React.FC = () => {
  const [nurse1Patient, setNurse1Patient] = useState<any>(null);
  const [nurse2Patient, setNurse2Patient] = useState<any>(null);
  const [nurse3Patient, setNurse3Patient] = useState<any>(null);
  const [loadingForms, setLoadingForms] = useState(true);
  const { setActivePatient } = useOutletContext<any>();
  const [loadError, setLoadError] = useState<string | null>(null);
  const [showADForm, setShowADForm] = useState(false);
  const [visibleForms, setVisibleForms] = useState<AllowedForm[]>([]);
  const [activeIdx, setActiveIdx] = useState(0);
  const [activeTab, setActiveTab] = useState<"nurse 1" | "nurse 2" | "nurse 3">(
    "nurse 1",
  );

  const FORM_COMPONENTS: Record<string, (emrId: string) => JSX.Element> = {
    "VITALS EXAMINATION": (emrId) => <VitalsExaminationForm emrId={emrId} />,
    VITALS: (emrId) => <VitalsExaminationForm emrId={emrId} />,
    "B&U SAMPLE": (emrId) => <BUSampleForm emrId={emrId} />,
    "BLOOD AND URINE SAMPLE COLLECTED": (emrId) => (
      <BUSampleForm emrId={emrId} />
    ),
    "ATOPIC DERMATITIS": (emrId) => (
      <ADMinorSymptomsExaminationForm emrId={emrId} />
    ),
    "AD MINOR SYMPTOMS EXAMINATION": (emrId) => (
      <ADMinorSymptomsExaminationForm emrId={emrId} />
    ),
    "PHYSICAL EXAMINATION": (emrId) => (
      <PhysicalExaminationForm emrId={emrId} />
    ),
    "ADMINOR SYSPTOMS EXAMINATION": (emrId) => (
      <ADMinorSymptomsExaminationForm emrId={emrId} />
    ),
    "ANTHROPOMETRIC MEASUREMENT": (emrId) => (
      <AnthropometricMeasurementForm emrId={emrId} />
    ),
    ANTHROPOMETRY: (emrId) => <AnthropometricMeasurementForm emrId={emrId} />,
    "BLOOD AND URIN SAMPLE COLLECTED": (emrId) => (
      <BUSampleForm emrId={emrId} />
    ),
    "BLOOD SAMPLE": (emrId) => <BUSampleForm emrId={emrId} />,
    "BLOOD SAMPLE SENT TO LAB": (emrId) => <BnuSampleForm emrId={emrId} />,
    "LAB REPORT": (emrId) => <LabReportForm emrId={emrId} />,
    "VISION SCREENING": (emrId) => <VisionScreeningForm emrId={emrId} />,
    "ORAL IMAGING": (emrId) => <OralImagingForm emrId={emrId} />,
    "CARIOGRAM SALAIVA SAMPLE": (emrId) => <SalivaSampleForm emrId={emrId} />,
    "CARIOGRAM INPUT": (emrId) => <CariogramInputForm emrId={emrId} />,
    "AUDIOLOGY SCREENING": (emrId) => <AudiologyScreeningForm emrId={emrId} />,
  };

  const queueMap = {
    "nurse 1": "NURSE1_Q",
    "nurse 2": "NURSE2_Q",
    "nurse 3": "NURSE3_Q",
  };

  const activeQueueApi = queueMap[activeTab];

  const storageKey = `selectedPatient_${queueMap[activeTab]}`;

  const loadPatient = () => {
    try {
      const stored = sessionStorage.getItem(storageKey);

      if (stored) {
        const parsed = JSON.parse(stored);

        if (activeTab === "nurse 1") {
          setNurse1Patient((prev: any) =>
            JSON.stringify(prev) !== JSON.stringify(parsed) ? parsed : prev,
          );
        }

        if (activeTab === "nurse 2") {
          setNurse2Patient((prev: any) =>
            JSON.stringify(prev) !== JSON.stringify(parsed) ? parsed : prev,
          );
        }

        if (activeTab === "nurse 3") {
          setNurse3Patient((prev: any) =>
            JSON.stringify(prev) !== JSON.stringify(parsed) ? parsed : prev,
          );
        }
      } else {
        if (activeTab === "nurse 1") {
          setNurse1Patient(null);
        }
        if (activeTab === "nurse 2") {
          setNurse2Patient(null);
        }
        if (activeTab === "nurse 3") {
          setNurse3Patient(null);
        }
      }
    } catch {
      if (activeTab === "nurse 1") {
        setNurse1Patient(null);
      }

      if (activeTab === "nurse 2") {
        setNurse2Patient(null);
      }

      if (activeTab === "nurse 3") {
        setNurse3Patient(null);
      }
    }
  };

  useEffect(() => {
    loadPatient();
  }, [activeTab]); // ✅ IMPORTANT

  // useEffect(() => {
  //   if (activeTab === "nurse 1") {
  //     setActivePatient(nurse1Patient ?? null);
  //   } else {
  //     setActivePatient(null);
  //   }
  // }, [activeTab, nurse1Patient, setActivePatient]);

  useEffect(() => {
    if (activeTab === "nurse 1") {
      setActivePatient(nurse1Patient ?? null);
    } else if (activeTab === "nurse 3") {
      setActivePatient(nurse3Patient ?? null);
    } else {
      setActivePatient(null);
    }
  }, [activeTab, nurse1Patient, nurse3Patient, setActivePatient]);

  useEffect(() => {
    const handler = () => loadPatient();
    window.addEventListener("storage", handler);
    window.addEventListener("patientUpdated", handler);
    return () => {
      window.removeEventListener("storage", handler);
      window.removeEventListener("patientUpdated", handler);
    };
  }, []);

  const centerId =
    sessionStorage.getItem("centerId") ||
    localStorage.getItem("centerId") ||
    "";

  const activePatientData =
    activeTab === "nurse 1"
      ? nurse1Patient
      : activeTab === "nurse 2"
        ? nurse2Patient
        : activeTab === "nurse 3"
          ? nurse3Patient
          : null;

  const emrId =
    activePatientData?.child?.childId || activePatientData?.emrId || "";

  const [isStarted, setIsStarted] = useState(false);

  useEffect(() => {
    const checkADCondition = async () => {
      if (activeTab !== "nurse 1") {
        setShowADForm(false);
        return;
      }

      if (!emrId) {
        console.log("EMR ID not available yet");
        setShowADForm(false);
        return;
      }

      try {
        console.log("EMR ID =", emrId);
        console.log("REQUEST URL =", `/api/scoring/scoresId/${emrId}/health`);

        const { data } = await api.Questionnair.get(
          `/api/scoring/scoresId/${emrId}/health`,
        );

        console.log("FULL RESPONSE =", data);

        const answer = data?.scores?.resultsById?.["1220"];

        console.log("1220 Answer =", answer);
        console.log("Uppercase =", String(answer).toUpperCase());

        const shouldShowAD =
          String(answer).toUpperCase() === "YES" ||
          String(answer).toUpperCase() === "MAYBE";

        console.log("Condition Result =", shouldShowAD);

        if (shouldShowAD) {
          console.log("SETTING TRUE");
          setShowADForm(true);
        } else {
          console.log("SETTING FALSE");
          setShowADForm(false);
        }
      } catch (err) {
        console.error("Failed to fetch 1220 condition", err);
        setShowADForm(false);
      }
    };

    checkADCondition();
  }, [activeTab, emrId]);

  useEffect(() => {
    setIsStarted(false);
  }, [activePatientData?._id]);

  useEffect(() => {
    const handler = () => {
      setIsStarted(true);
    };

    window.addEventListener("patientUpdated", handler);

    return () => {
      window.removeEventListener("patientUpdated", handler);
    };
  }, []);

  console.log("ACTIVE TAB =", activeTab);
  console.log("ACTIVE PATIENT =", activePatientData);
  console.log("EMR ID =", emrId);
  console.log("STATE =", activePatientData?.state);

  const canCollectBUSample = activePatientData?.canCollectBUSample === true;

  useEffect(() => {
    let stop = false;

    const build = () => {
      const user = loadUserAnywhere();
      if (!user) return;

      const backendForms =
        user?.roleAssignments?.[0]?.roleId?.formIds ?? user?.forms ?? [];

      const built: AllowedForm[] = [];

      const addedLabels = new Set<string>();

      backendForms.forEach((bf: BackendForm) => {
        const nameN = normalize(bf.name);
        const keyN = normalize(bf.key);

        const isBUSampleForm =
          nameN.includes("B&U SAMPLE") ||
          keyN.includes("B&U SAMPLE") ||
          nameN.includes("BLOOD AND URINE SAMPLE") ||
          keyN.includes("BLOOD AND URINE SAMPLE") ||
          nameN.includes("BLOOD AND URIN SAMPLE") ||
          keyN.includes("BLOOD AND URIN SAMPLE");

        if (isBUSampleForm && !canCollectBUSample) {
          return;
        }

        const renderer =
          FORM_COMPONENTS[nameN] ?? FORM_COMPONENTS[keyN] ?? null;

        if (renderer) {
          // const label = bf.name || bf.key || "Form";
          let label = bf.name || bf.key || "Form";

          if (
            normalize(label).includes("BLOOD AND URIN SAMPLE") ||
            normalize(label).includes("BLOOD AND URINE SAMPLE")
          ) {
            label = "B&U SAMPLE";
          }

          if (!addedLabels.has(normalize(label))) {
            addedLabels.add(normalize(label));

            built.push({
              id: bf._id || nameN,
              label,
              render: renderer,
            });
          }
        }
      });

      setVisibleForms(built);
      setLoadingForms(false);
    };

    build();
    return () => {
      stop = true;
    };
  }, [canCollectBUSample]);

  console.log(
    "visibleForms",
    visibleForms.map((x) => x.label),
  );

  // 🔥 NEW: Filter forms based on active nurse tab
  // const filteredForms = visibleForms.filter((form) =>
  //   NURSE_FORM_FILTERS[activeTab].includes(normalize(form.label)),
  // );

  const filteredForms = visibleForms.filter((form) => {
    const normalizedLabel = normalize(form.label);

    if (!NURSE_FORM_FILTERS[activeTab].includes(normalizedLabel)) {
      return false;
    }

    if (
      activeTab === "nurse 1" &&
      normalizedLabel === "AD MINOR SYMPTOMS EXAMINATION" &&
      !showADForm
    ) {
      return false;
    }

    return true;
  });

  return (
    <div className="lab-reports-page" style={{ display: "flex" }}>
      {/* ✅ LEFT QUEUE */}
      {/* ✅ LEFT QUEUE */}

      {activeTab === "nurse 1" && (
        <Nurse1PatientQueue
          key="NURSE1_QUEUE"
          centerId={centerId}
          queueApi="NURSE1_Q"
          preserveMatrixOrder={true}
          stationId="NURSE1"
          activeId={
            (nurse1Patient as any)?._id ||
            sessionStorage.getItem("activeNurse1PatientId") ||
            ""
          }
          onSelect={(selectedPatient) => {
            console.log("SELECTED PATIENT STATE", selectedPatient?.state);
            if (!selectedPatient) return;

            // ✅ keep latest selected patient in state
            setNurse1Patient(selectedPatient as any);

            // ✅ keep selected id synced
            sessionStorage.setItem(
              "selectedPatient_NURSE1_Q",
              JSON.stringify(selectedPatient),
            );

            // ✅ IMPORTANT
            sessionStorage.setItem(
              "activeNurse1PatientId",
              selectedPatient._id,
            );

            window.dispatchEvent(new Event("patientUpdated"));
          }}
        />
      )}

      {activeTab === "nurse 2" && (
        <Nurse2PatientQueue
          key="NURSE2_QUEUE"
          centerId={centerId}
          stationId="NURSE2"
          activeId={
            (nurse2Patient as any)?._id ||
            sessionStorage.getItem("activeNurse2PatientId") ||
            ""
          }
          onSelect={(selectedPatient) => {
            if (!selectedPatient) return;

            setNurse2Patient(selectedPatient as any);

            sessionStorage.setItem(
              "selectedPatient_NURSE2_Q",
              JSON.stringify(selectedPatient),
            );

            sessionStorage.setItem(
              "activeNurse2PatientId",
              selectedPatient._id,
            );

            window.dispatchEvent(new Event("patientUpdated"));
          }}
        />
      )}

      {activeTab === "nurse 3" && (
        <Nurse3PatientQueue
          key="NURSE3_QUEUE"
          centerId={centerId}
          stationId="NURSE3"
          activeId={
            (nurse3Patient as any)?._id ||
            sessionStorage.getItem("activeNurse3PatientId") ||
            ""
          }
          onSelect={(selectedPatient) => {
            if (!selectedPatient) return;

            setNurse3Patient(selectedPatient as any);

            sessionStorage.setItem(
              "selectedPatient_NURSE3_Q",
              JSON.stringify(selectedPatient),
            );

            sessionStorage.setItem(
              "activeNurse3PatientId",
              selectedPatient._id,
            );

            window.dispatchEvent(new Event("patientUpdated"));
          }}
        />
      )}

      {/* ✅ RIGHT CONTENT */}
      <section className="bnu-main" style={{ flex: 1 }}>
        {activeTab === "nurse 1" && (
          <Nurse1ActivePatientCard showActions={true} stationId="NURSE1" />
        )}

        {activeTab === "nurse 2" && (
          <Nurse2ActivePatientCard
            activePatient={nurse2Patient}
            showActions={true}
            stationId="NURSE2"
          />
        )}

        {activeTab === "nurse 3" && (
          <Nurse3ActivePatientCard
            activePatient={nurse3Patient}
            showActions={true}
            stationId="NURSE3"
          />
        )}

        {/* 🔥 Nurse Tabs */}
        <div className="nurse2-subtabs">
          {["nurse 1", "nurse 2", "nurse 3"].map((tab) => (
            <button
              key={tab}
              className={`nurse2-subtab ${activeTab === tab ? "active" : ""}`}
              onClick={() => {
                setActiveTab(tab as any);
                setActiveIdx(0);
                setIsStarted(false);
              }}
            >
              {tab.toUpperCase()}
            </button>
          ))}
        </div>

        {/* ✅ Existing Form Tabs */}
        <div className="nurse2-subtabs">
          {filteredForms.map((form, i) => (
            <button
              key={form.id}
              className={`nurse2-subtab ${activeIdx === i ? "active" : ""}`}
              onClick={() => setActiveIdx(i)}
            >
              {form.label}
            </button>
          ))}
        </div>

        {/* ✅ Form Render */}

        {isStarted && filteredForms[activeIdx] && emrId && (
          <div key={`${filteredForms[activeIdx].id}-${emrId}`}>
            {filteredForms[activeIdx].render(emrId)}
          </div>
        )}
      </section>
    </div>
  );
};

export default NursePage;
